import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TreePath } from '@interfaces/TreePath';
import { OverBudgetResult } from '../../shared/services/models/over-budget-result';

@Component({
  selector: 'pop-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.less']
})
export class ErrorDialogComponent {
  public overBudgetErrors: OverBudgetResult[];
  public budgetFromGP = false;
  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: { budgetFromGP: boolean; overBudgetErrors: OverBudgetResult[] }
  ) {
    this.overBudgetErrors = data.overBudgetErrors;
    this.budgetFromGP = data.budgetFromGP;
  }

  public treePathToString(treePath: TreePath) {
    return [treePath.level1Code, treePath.level2Code, treePath.departmentCode, treePath.categoryCode]
      .filter(val => !!val)
      .join(' > ');
  }
}
